var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 19.9987C24.6037 19.9987 28.3346 16.2677 28.3346 11.6654C28.3346 7.06299 24.6037 3.33203 20.0013 3.33203C15.3989 3.33203 11.668 7.06299 11.668 11.6654C11.668 16.2677 15.3989 19.9987 20.0013 19.9987Z",
    fill: "#B79843"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0016 24.168C11.6516 24.168 4.85156 29.768 4.85156 36.668C4.85156 37.1346 5.21823 37.5013 5.6849 37.5013H34.3182C34.7849 37.5013 35.1516 37.1346 35.1516 36.668C35.1516 29.768 28.3516 24.168 20.0016 24.168Z",
    fill: "#B79843"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c65d32ed0829a057023174414a3e38af.svg";
export { ForwardRef as ReactComponent };